import { Model } from '@shared/models/model';
import { Expose, Type } from 'class-transformer';
import { TradeLane } from './trade-lane.model';
import { Status } from '../../shared-features/enums/shared-enums.enum';
import { Media } from '../../shared-features/models/media.model';
import { Fleet } from '../../fleets/models/fleet.model';
import { Customer } from '../../customers/models/customer.model';
import { User } from '../../users/models/user.model';
import { ContractUnifiedTypes } from '@shared-features/enums';


export class Contract extends Model {
  @Expose() id: number;
  @Expose() name: string;
  @Expose() expiryDate: number;
  @Expose() affectiveDate: number;

  @Type(() => Media)
  @Expose() documents: Media[];

  @Type(() => TradeLane)
  @Expose() tradeLanes: TradeLane[];

  @Expose() status: Status;

  @Expose() type: ContractUnifiedTypes;
  // ContractType;

  @Type(() => Fleet)
  @Expose() fleet: Fleet;

  @Type(() => Customer)
  @Expose() customer: Customer;

  @Type(() => User)
  @Expose() createdBy: User;

  @Expose() createdAt: Date;

  @Type(() => User)
  @Expose() updatedBy: User;

  @Expose() updatedAt: Date;


}
